export { getOptimizedMagentoImageSrcSet } from "./getOptimizedMagentoImageSrcSet";
